export default [
  {
    header: 'Gestión Humana',
    resource: 'GH Nominas'
  },

  {
    title: 'Nómina',
    icon: 'UserCheckIcon',
    children: [
      {
        title: 'Nómina actual',
        route: 'current',
        action: 'menu',
        resource: 'GH Nominas'
      },
      {
        title: 'Solicitudes',
        children: [
          {
            title: 'Detalle',
            route: 'request',
            action: 'menu',
            resource: 'GH Nominas'
          },
          {
            title: 'Semanas',
            route: 'weeks',
            action: 'menu',
            resource: 'GH Nominas'
          },
        ]
      },
    ]
  },


  {
    title: 'Admin Gestión Humana',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Nómina actual',
        route: 'admin_currents',
        action: 'menu',
        resource: 'GH Admin',
      },
      {
        title: 'Todas las solicitudes',
        route: 'admin_requests',
        action: 'menu',
        resource: 'GH Admin',
      },
      {
        title: 'Reportes',
        route: 'admin_reports',
        action: 'menu',
        resource: 'GH Admin',
      },
      {
        title: 'Inventario',
        route: 'admin_inventory',
        action: 'menu',
        resource: 'GH Admin',
      },
      {
        title: 'Organigrama',
        route: 'admin_org_chart',
        action: 'menu',
        resource: 'GH Admin',
      },
      {
        title: 'Logs',
        route: 'admin_logs',
        action: 'menu',
        resource: 'GH Admin',
      },
      {
        title: 'Configuración',
        children: [
          {
            title: 'Usuarios',
            route: 'admin_users',
            action: 'menu',
            resource: 'GH Admin',
          },
          {
            title: 'Incrementales',
            route: 'admin_incrementals_list',
            action: 'menu',
            resource: 'GH Admin',
          },
          {
            title: 'Año Presupuesto',
            route: 'admin_budget_year',
            action: 'menu',
            resource: 'GH Admin',
          },
        ]
      },
    ]
  },

  {
    title: 'Admin Valorización',
    icon: 'ActivityIcon',
    children: [
      {
        title: 'Parámetros',
        route: 'Parámetros',
        action: 'menu',
        resource: 'GH Valorizacion',
      },
      {
        title: 'Valorización',
        route: 'Valuation',
        action: 'menu',
        resource: 'GH Valorizacion',
      },
    ]
  },

  {
    title: 'Descargas Sunat',
    icon: 'fa-solid fa-users',
    route: 'registronominas',
    action: 'menu',
    resource: 'Registro Nominas',
  },

]
